// ***************************************
// flowSettings
//
// This object contains the setting for the flow.
//
// Copyright 2015 Tingly Games B.V.
// Last Changed: 24-10-2015
// ***************************************
import { angrybirds_regular } from "../../game_logic/code/AssetDefinitions/FontDefinitions";
import { s_popup_darkblue_rect, s_howtoplay_1, s_howtoplay_2, s_howtoplay_3, s_howtoplay_4, s_howtoplay_5, s_btn_round_orange_small, s_popup_close, s_bar_title_green, s_bar_container_green } from "../../game_logic/code/AssetDefinitions/ImageDefinitions";
import { a_music } from "../../game_logic/code/AssetDefinitions/SoundDefinitions";
import { AngryLobbyDialog } from "../../game_logic/code/LobbyCode/AngryLobbyDialog";
import { AngryLobbyItem } from "../../game_logic/code/LobbyCode/AngryLobbyItem";
import { SplashScreenDialog } from "../../game_logic/code/SplashScreenDialog";
import { dictionaryVar } from "../../game_logic/frameworkDictionaryOverwrite/framework3_dictionary";
// We use a function for this to make sure all global variables used actually exist
export var flowSettings = function () {
    "use strict";
    return {
        //
        // The properties of the various dialogs
        //
        analyticsDefaults: {
            // General settings
            providers: "gameAnalytics",
            version: "1",
            localStorageKey: "analyticsUserId",
            showDebug: true, // Whether to show debug information in test mode
            // Game Analytics settings
            //gameAnalyticsBaseUrl: "http://api.gameanalytics.com/1/",    // Basic url for game analytics
            //gameAnalyticsGameKey: "b8a1fd0e8b6c0b4b7779558d6d1d22f6",                            // Game key as provided by game analytics
            //gameAnalyticsSecretKey: "b0b5be0f077c4c8ca3c5d40d58b588015f3c525b"                           // Secret key as provided by game analytics
        },
        storageDefaults: {
        //remote: "fb"
        },
        splashScreenDialogProperties: {
            image: undefined,
            color: "white",
            duration: 2 // The duration in seconds
        },
        // 		loadScreenDialogProperties: {                               // The properties for the load screen
        // 			fillImage: s_logo_tinglygames_background,                   // Image used to fill the background
        // 			backgroundImage: s_dialog_load_frame,                       // Background image for the dialog
        // 			gameLogo: s_logo,                                      // Game logo
        // 			companyLogo: s_logo_tinglygames_small                       // Company logo
        // 		},
        //
        // 		titleScreenDialogProperties: {                                  // The properties for the title screen
        // 			backgroundImage: s_screen_start,                        // Background image for the dialog
        // 			gameLogo: s_logo,                                 // Game logo
        // 			companyLogo: [s_logo_tinglygames_small],      // Company logo
        // 			companyLogoPosition: [{x: -100, y: 598}],
        // 			companyLogoLink: ["http://www.coolgames.com"],
        // 			modeButtonCreate: false,
        // 			languageButtonCreate: false,
        // 			playButtonX: 0,
        // 			playButtonY: 138,
        // 			gameLogoX: 0,
        // 			playButtonIcon: s_buttons_bigtext_play,
        // 			playButtonImage: s_btn_standard,
        // 			menuButtonIcon: undefined,
        // 			menuButtonX: 65,
        // 			menuButtonY: 580,
        // 			menuButtonImage: s_btn_small_options,
        // 			menuButtonWidth: 100,
        // 			menuButtonHeight: 92,
        // 			multiplayButtonY: 80,
        // 			hasBuyButton: false
        // 		},
        //
        // 		titleLanguageDialogProperties: {                                // The properties for the language selection dialog
        // 			width: 600, height: 600,
        // 			buttonScrollBoxWidth: 600, buttonScrollBoxHeight: 590,
        // 			buttons: [[{image: [s_tgf_button ,s_tgf_buttonSelect]}],
        // 					 [{image: [s_tgf_button ,s_tgf_buttonSelect]}],
        // 					 [{image: [s_tgf_button ,s_tgf_buttonSelect]}],
        // 					 [{image: [s_tgf_button ,s_tgf_buttonSelect]}],
        // 					 [{image: [s_tgf_button ,s_tgf_buttonSelect]}],
        // 					 [{image: [s_tgf_button ,s_tgf_buttonSelect]}],
        // 					 [{image: [s_tgf_button ,s_tgf_buttonSelect]}],
        // 					 [{image: [s_tgf_button ,s_tgf_buttonSelect]}],
        // 					 [{image: [s_tgf_button ,s_tgf_buttonSelect]}],
        // 					 [{image: [s_tgf_button ,s_tgf_buttonSelect]}],
        // 					 [{image: [s_tgf_button ,s_tgf_buttonSelect]}]]
        // 		},
        //
        // 		titleOptionsDialogProperties: {                             // The properties for the title screen options dialog
        // 			backgroundImage: s_overlay_options,                         // Background image for the dialog
        // 			hasCloseButton: true,                                       // Whether it has a close button
        // 			optionSettings:["tutorial", "oldSound", "oldLanguage", "moregames", "about"],          // Array of options to show
        // 			marginTop: 16,
        // 			//titleFont: Lobster,
        // 			titleDictionaryKey: "optionsTitle",
        // 			marginLeft: 170,
        // 			marginRight: 175
        // 		},
        //
        // 		levelMapProperties: {
        // 			menuButtonX: 65,
        // 			menuButtonY: 580,
        // 			menuButtonImage: s_btn_small_options,
        // 			menuButtonWidth: 100,
        // 			menuButtonHeight: 92,
        // 			//levelButtonFont: OpenSansExtraBold,
        // 			//levelButtonFontLocked: OpenSansExtraBoldLocked,
        // 			//gateFonts: [{fontFace: f_open_sans_bold.fontFace, fontSize: 22, fillColor: "#8f7c64"}, {fontFace: f_open_sans_bold.fontFace, fontSize: 22, fillColor: "#d0853e"}, {fontFace: f_open_sans_bold.fontFace, fontSize: 22, fillColor: "#592902"}, {fontFace: f_open_sans_bold.fontFace, fontSize: 22, fillColor: "#d0853e"}],
        // 			//indicatorImage: s_profilepicture_penguin,
        // 			//comingsoonFont: LobsterComingsoon
        // 		},
        //
        // 		levelSelectionProperties: {
        // 			//popUpBackgroundImage: s_overlay_worldmap_levelselect,
        // 			closeButtonWidth:400,
        // 			hasCloseButton: true,
        // 			levelPressed: 0,
        // 			//titleFont: Lobster,
        // 			//labelTitleFont: {fontFace: f_lobster.fontFace, fontSize: 36, fillColor: "#ea8c9d"},
        // 			//labelFont: {fontFace: f_open_sans_bold.fontFace, fontSize: 18, fillColor: "#452f5a"},
        // 			titleTextDict: "LevelHeader",
        // 			marginTop: 16,
        // 			labelTitleDictionaryKey: "",
        // 			labelY: 55
        // 		},
        //
        // 		optionsAboutDialogProperties: {                             // The properties for the about screen
        // 			width: 600, height: 600,
        // 			aboutBackgroundImage: s_tutorial,
        // 			hasCloseButton: true
        // 		},
        //
        // 		optionsTutorialDialogProperties: {                          // The properties for the tutorial screen
        // 			width: 578, height: 600,
        // 			titlePercentage: 18,
        // 			imagePercentage: 30,
        // 			messagePercentage: 40,
        // 			buttonPercentage: 10,
        // 			backgroundImage: s_tutorial,
        // 			//previousButtonImage: s_tutorialButton_previous_pink,
        // 			//nextButtonImage: s_tutorialButton_next_pink,
        // 			//closeButtonImage: s_tutorialButton_exit_pink,
        // 			//tutorial:[{image: s_tutorial_01, titleKey: "TutorialHeader_01", messageKey: "TutorialText_01", animationSpeed: 0}, {image: s_tutorial_02, titleKey: "Tutorial_Header_02", messageKey: "TutorialText_02", animationSpeed: 0}
        // 			//,{image: s_tutorial_04, titleKey: "Tutorial_Header_03", messageKey: "TutorialText_03", animationSpeed: 0},
        // 			//{image: s_tutorial_05, titleKey: "Tutorial_Header_04", messageKey: "TutorialText_04", animationSpeed: 0},{image: s_tutorial_06, titleKey: "Tutorial_Header_05", messageKey: "TutorialText_05", animationSpeed: 0},
        // 			//{image: s_tutorial_07, titleKey: "Tutorial_Header_06", messageKey: "TutorialText_06", animationSpeed: 0},{image: s_tutorial_08, titleKey: "Tutorial_Header_07", messageKey: "TutorialText_07", animationSpeed: 0},
        // 			//{image: s_tutorial_09, titleKey: "Tutorial_Header_08", messageKey: "TutorialText_08", animationSpeed: 0},{image: s_tutorial_010, titleKey: "Tutorial_Header_09", messageKey: "TutorialText_09", animationSpeed: 0},
        // 			//{image: s_tutorial_011, titleKey: "Tutorial_Header_10", messageKey: "TutorialText_10", animationSpeed: 0},{image: s_tutorial_012, titleKey: "Tutorial_Header_11", messageKey: "TutorialText_11", animationSpeed: 0}]
        // 		},
        //
        // 		completionScreenDialogProperties: {                             // The properties for the completion screen
        // 			backgroundImage: typeof s_completion_background !== "undefined" ? s_completion_background : null,                   // Background image for the dialog
        // 			congratulationImage: typeof s_completion_congratulation !== "undefined" ? s_completion_congratulation : null,       // Congratulation image for the dialog
        // 			congratulationFont: typeof f_completion_congratulation !== "undefined" ? f_completion_congratulation : angrybirds_regular_texttitle, // Font for the congratulation text
        // 			continueButtonImage: typeof s_completion_continue !== "undefined" ? s_completion_continue : s_tgf_button,           // Image for the continue button
        // 			continueButtonFont: typeof f_completion_continue !== "undefined" ? f_completion_continue : angrybirds_regular             // Font for the continue button
        // 		},
        //
        // 		startPlayDialogProperties: {                                // The properties for the play start dialog
        // 			width: 780, height: 300
        // 		},
        //
        // 		endPlayWonDialogProperties: {                               // The properties for the end play edialog when won
        // 			backgroundImage: typeof s_overlay_win !== "undefined" ? s_overlay_win : undefined,
        // //          width: 500, height: 300,
        // 			//buttons: [ { text: "Back", id: "title" }, { text: "Retry", id: "restart" }, { text: "Next", id: "next" } ],
        // 			showSettings: ["stars","score", "highscore"],
        // 			marginTop: 16,
        // 			marginLeft: 450,
        // 			marginRight: 460,
        // 			//titleFont: Lobster,
        // 			//primaryStatsHeaderFont: {fontFace: f_open_sans_bold.fontFace, fontSize: 24, fillColor: "#ea8c9d"},
        // 			//primaryStatsFont: {fontFace: f_open_sans_bold.fontFace, fontSize: 24, fillColor: "#120825"},
        // 			//secondaryStatsHeaderFont: {fontFace: f_open_sans_bold.fontFace, fontSize: 24, fillColor: "#ea8c9d"},
        // 			//secondaryStatsFont: {fontFace: f_open_sans_bold.fontFace, fontSize: 24, fillColor: "#120825"},
        // 			hasCloseButton:true,
        // 			closeButtonWidth:400,
        // 			primaryStatsHeaderDictionaryKey: "EndScore",
        // 			secondaryStatsHeaderDictionaryKey: "HighScore",
        // 			closeButtonId: "title",
        // 			nextButtonId: "restart",
        // 			titleDict:"LevelHeader",
        // 			hasPrimaryStats: true,
        // 			hasSecondaryStats: true
        // 		},
        //
        // 		endPlayLostDialogProperties: {                              // The properties for the end play dialog when lost
        // 			backgroundImage: typeof s_overlay_fail !== "undefined" ? s_overlay_fail : undefined,
        // 			//width: 500, height: 300,
        // 			//buttons: [ { text: "Back", id: "title" }, { text: "Retry", id: "restart" } ],
        // 			showSettings: ["score", "highscore"],
        // 			marginTop: 16,
        // 			marginLeft: 450,
        // 			marginRight: 460,
        // 			//titleFont: Lobster,
        // 			hasCloseButton:true,
        // 			closeButtonWidth:400,
        // 			closeButtonId: "title",
        // 			titleDict:"LevelHeader",
        // 			titleDictionaryKey: "LevelFailedHeader",
        // 			hasPrimaryStats: false,
        // 			hasSecondaryStats: false,
        // 			hasFailedLabel: true,
        // 			failLabelY: -145,
        // 			//failLabelFont: {fontFace: f_open_sans_bold.fontFace, fontSize: 24, fillColor: "#ffffff"},
        // 			failLabelDictionaryKey: ""
        // 		},
        // 		stageCompletedDialogProperties: {                           // The properties for the stage completed dialog
        // 			width: 500, height: 300
        // 		},
        //
        // //      gameTutorialDialogProperties: {                             // The properties for the in-game tutorial dialog
        // //          width: 500, height: 300
        // //      },
        //
        // 		gameOptionsDialogProperties: {                              // The properties for the title screen options dialog
        // 			backgroundImage: s_overlay_options,                         // Background image for the dialog
        // 			hasCloseButton: true,                                       // Whether it has a close button
        // 			optionSettings:["exit", "oldSound", "oldLanguage", "moregames", "about"] ,  // Array of options to show
        // 			buttonExitDictionaryKey: "optionsStartScreen",
        // 			marginTop: 16,
        // 			marginLeft: 170,
        // 			marginRight: 175,
        // 			//titleFont: Lobster,
        // 			titleDictionaryKey: "optionsTitle"
        // 		},
        //
        // 		inGameOptionsDialogProperties:{
        // 			backgroundImage: s_overlay_options,                         // Background image for the dialog
        // 			hasCloseButton: true,                                       // Whether it has a close button
        // 			optionSettings:["resume", "tutorial","oldSound", "moregames", "quit"] ,  // Array of options to show
        // 			marginTop: 16,
        // 			marginLeft: 170,
        // 			marginRight: 175,
        // 			//titleFont: Lobster,
        // 			titleDictionaryKey: "optionsTitle",
        // 			quitYesButtonId: "title",
        // 			//quitTitleFont : {fontFace: f_open_sans_bold.fontFace, fontSize: 32, fillColor: "#452f5a", baseline: "middle", align: "center"}
        // 		},
        tutorialDialogProperties: {
            backgroundImage: s_popup_darkblue_rect,
            darken: true,
            width: 800, height: 650,
            titlePercentage: 0,
            imagePercentage: 60,
            messagePercentage: 40,
            buttonPercentage: 0,
            marginTop: 3,
            marginBottom: 100,
            tutorial: [
                { image: s_howtoplay_1, titleKey: "HOW_TO_PLAY_HEADER", messageKey: "TUT_GOAL_TEXT", animationSpeed: 1 },
                { image: s_howtoplay_2, titleKey: "HOW_TO_PLAY_HEADER", messageKey: "TUT_POWERUPS_TEXT", animationSpeed: 1 },
                { image: s_howtoplay_3, titleKey: "HOW_TO_PLAY_HEADER", messageKey: "TUT_SELECT_TEXT", animationSpeed: 1 },
                { image: s_howtoplay_4, titleKey: "HOW_TO_PLAY_HEADER", messageKey: "TUT_SHOOT_TEXT", animationSpeed: 1 },
                { image: s_howtoplay_5, titleKey: "HOW_TO_PLAY_HEADER", messageKey: "TUT_ABILITIES_TEXT", animationSpeed: 1 },
            ],
            imageProperties: {
                xScale: 1,
                yScale: 1
            },
            previousButtonImage: s_btn_round_orange_small,
            nextButtonImage: s_btn_round_orange_small,
            closeButtonImage: s_popup_close,
            showButtons: true,
            titleFont: {
                fontFace: angrybirds_regular.fontFace,
                fontSize: 36,
                fillColor: "#ffffff",
                align: "center",
                baseline: "middle"
            },
            messageFont: {
                fontFace: angrybirds_regular.fontFace,
                fontSize: 36,
                fillColor: "#fefefe",
                align: "center",
                baseline: "middle",
                shadow: { active: true, color: 'rgba(50, 49, 65, 0.7)', offsetX: 2, offsetY: 3, blur: 1, distance: 3 }
            }
        },
        lobbyScreenDialogProperties: {
            backgroundImage: undefined,
            imageTop: s_bar_title_green,
            imageItem: s_bar_container_green,
            imageItemLast: null,
            nineSliceWidth: 700,
            listSpacing: -80,
            sliceMargin: [20, 20, 20, 20],
            listOffset: [
                {
                    x: 0,
                    y: 120
                },
                {
                    x: 0,
                    y: 30
                },
                {
                    x: 0,
                    y: 30
                },
                {
                    x: 0,
                    y: 30
                }
            ],
            isTopNineSliced: true,
            isItemNineSliced: true,
            componentLobbyListItemClass: AngryLobbyItem,
            headings: {
                active: 'YOUR_TURN_HEADER',
                inactive: 'THEIR_TURN_HEADER',
                done: 'COMPLETED_MATCHES_HEADER',
                suggested: 'SUGGESTED_PLAYERS_HEADER'
            },
            font: {
                fontFace: angrybirds_regular.fontFace,
                shadow: { active: true, color: 'rgba(9, 56, 18, 0.9)', offsetX: 2, offsetY: 3, blur: 1, distance: 4 }
            },
            fontTopFillColor: "#FEFEFE",
            fontTopAlign: 'left',
            fontTopSize: 36,
            fontTopOffset: {
                x: -330,
                y: 15
            },
        },
        tgfAdsProperties: {
            providers: "none",
            adTimer: 1
        },
        tgfFirebaseProperties: {},
        adDialogProperties: {
            provider: "none",
            fillImage: null,
            hasFrame: true
        },
        adStageDialogProperties: {
            provider: "none",
            hasFrame: true
        },
        flow: {
            //
            // Which dialogs to use (when undefined the default is used)
            //
            splashScreenDialog: SplashScreenDialog,
            loadScreenDialog: undefined,
            // optionsAboutDialog: tgfDialogs.AboutScreen,         // The dialog to use for the about dialog
            // optionsTutorialDialog: tgfDialogs.Tutorial,                   // The dialog to use for the tutorial dialog        
            // levelScreenDialog: tgfDialogs.LevelMap,             // The dialog to use for the level selection screen
            // levelSelectionDialog: tgfDialogs.LevelPopUp,
            // startPlayDialog: tgfDialogs.LevelPlay,              // The dialog to use for start play
            // startMultiplayDialog: tgfDialogs.LevelPlay,              // The dialog to use for start play
            // matchMakingDialog: tgfDialogs.MatchMaking,
            // endPlayWonDialog: tgfDialogs.EndPlayWon,            // The dialog to use for end play when won
            // endPlayLostDialog: tgfDialogs.EndPlayLost,          // The dialog to use for end play when lost
            stageCompletedDialog: undefined,
            //          gameTutorialDialog: undefined,                      // The dialog to use for the in-game tutorial
            // gameOptionsDialog:  tgfDialogs.OptionScreen,                        // The dialog to use for the in-game options
            // inGameOptionsDialog: tgfDialogs.OptionScreen,
            // facebookLoginDialog: tgfDialogs.LoginScreen,
            // Whether to show certain dialogs
            showSplashScreenDialog: true,
            // Which dialogs to use (when undefined the default is used)
            showLoadScreenDialog: false,
            showLevelScreenDialog: false,
            showLevelSelectionDialog: false,
            showFacebookLogin: false,
            // Settings related to the title screen
            // adDialog: tgfDialogs.AdDialog,
            // midrollDialog: tgfDialogs.AdDialogStage,
            lobbyScreenDialog: AngryLobbyDialog,
            // titleScreenDialog: tgfDialogs.TitleScreen2,         // The dialog to use for the title screen
            // titleOptionsDialog: tgfDialogs.OptionScreen,        // The dialog to use for the title screen options dialog
            // titleLanguageDialog: tgfDialogs.LanguageScreen, // The dialog to use for the title screen languages dialog
            showAdDialog: false,
            showMidroll: false,
            showTitleScreenDialog: false,
            showLanguageMenuDialog: true,
            showTitleMenuDialog: true,
            showAboutScreenDialog: true,
            showTutorialScreen: true,
            titleScreenMusic: a_music,
            //Setting related to the Game Screen
            showGameMenuDialog: true,
            //Setting related to the In Game Screen
            showInGameMenuDialog: true,
            // Settings related to the completion screen
            completionScreenDialog: undefined,
            showCompletionScreenDialog: true,
            completionScreenAction: "title",
            // Settings related to loading
            loadMoments: ["splashImages", "load", "fonts" /*"audio", "fonts", "spine"*/],
            loadRequired: ["splashImages", "load", "fonts" /*"spine"*/],
            loadMinTime: 0.5,
            loadMaxTime: 2 // Maximal loading time (in seconds) for the other moments before continuing
        },
        framework: {
            focusOnClick: false
        },
        errors: {},
        graphics: {
            transparent: false,
            areaWidth: 1366, areaHeight: 768,
            safeZoneLeft: 0, safeZoneTop: 0, safeZoneWidth: 1366, safeZoneHeight: 768
        },
        audio: {},
        dictionary: {
            dictionaries: [dictionaryVar],
            languages: {
                initial: "en-us"
            }
        },
        game: {},
    };
};
